import {UserAbsenceRequestBody, UserAbsenceResponseBody} from '@dms/api/shared';

/**
 * Ends an absence at `endedAt` and carries every other field through unchanged.
 *
 * The endpoint is a PUT that replaces the whole record, so any field omitted here
 * silently reverts to its backend default. That is how email delegation was lost
 * when a user returned early before T20-140031.
 */
export function getReturnEarlyRequestBody(
  absence: UserAbsenceResponseBody,
  endedAt: string
): UserAbsenceRequestBody {
  return {
    dateFrom: absence.dateFrom,
    dateTo: endedAt,
    absenceContactUserId: absence.absenceContactUser?.id ?? null,
    description: absence.description,
    forwardEmailsToDelegate: absence.forwardEmailsToDelegate,
  };
}
